import apiRequest from '@libs/apiRequest';
import { SHIFT } from 'common/redux.datasets';
import { call, put } from 'redux-saga/effects';
import { USERS } from 'user/redux.datasets';
import { setLoading, setSnack } from 'utilities/redux.actions';

export default function* (action) {
    const {
        meta: { handleSubmit = () => { } },
        payload,
        ...rest
    } = action;

    yield put(setLoading(true));

    try {
        const { data } = yield call(
            apiRequest,
            {
                url: `shift/delete?name=${payload.name}`,
                method: 'get'
            }
        );
        yield put(setLoading(false));
        yield put(setSnack({
            message: "Shift deleted successfully",
            type: 'success',
        }));
        yield put({
            type: "handleDelete",
            payload: {
                entity: SHIFT,
                value: data,
                key:"name"
            },
        });

        return handleSubmit(data);

    } catch (error) {
        yield put(setLoading(false));
        yield put(setSnack({
            message: error?.response?.data?.message || error?.message,
            type: 'error',
        }));

        return handleSubmit(error);
    }
}
